
  export const environment = {
    production: true,
    hmr : false,
    ipAddress: "undefined",
    apiBasePath: "https://api.staging.a-d.com.au",
    appBasePath: "https://www.staging.a-d.com.au",
    cdnBasePath: "https://d126h31mg8tzcs.cloudfront.net",
    apiRequestTimeout: 100000,
    whiteLabelConfig: {
      id: "undefined",
      application_key: "undefined"
    },
    GOOGLE_API_CLIENT_ID: "AIzaSyBQlZ-BsMGXSQ6q4NdJYPh830NnVWwO5Cw",
    GOOGLE_ANALYTICS_TRACKING_CODE: "G-HY05FPWKKC",
    GOOGLE_TAG_MANAGER_ID: "GTM-W8XKDF",
    defaultTemplate: "Showcase-Default",
    trinityAudioSrc: "https://trinitymedia.ai/player/trinity/2900006197/?poweredby=0&&voiceId=en-AU-OliviaNeural&FAB=t&pageURL=$$PAGE_URL$$",
    stateSearchRadius: 700000,
    effiClientId: "undefined",
    effiSrc: "/effi/bUjnlE1AER8l5mahFBl9np6vQpvtqFvJoKZoUAhBZdLk6DwAIouDYDXOwG3dRAwQ/build",
    bci:  undefined,
    brazeApiKey: "45dea42e-e14d-4bd1-b3a1-05745f21c16b",
    brazeEndpoint: "sdk.iad-07.braze.com"
  };
